<template>
  <v-dialog fullscreen persistent v-model="getModalCadastroContaReceber">
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title> Cadastro de Conta a Receber </v-card-title>
      <v-card-title>
        <v-flex xs12>
          <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
            <v-tab>
              <span>GERAL</span>
            </v-tab>

            <v-tab
              v-if="getContaReceber.id && getContaReceber.extrato.length > 0"
            >
              <span>EXTRATO</span>
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <v-form ref="form" class="px-3">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-autocomplete
                    class="mr-2 ml-2"
                    v-model="getContaReceber.cliente_id"
                    :items="getContatos"
                    item-text="nome"
                    item-value="id"
                    outlined
                    dense
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarContato"
                    label="Fornecedor/Cliente"
                    :rules="rules.cliente_id"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Nº do Documento"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.numero_documento"
                    :rules="rules.numero_documento"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    class="mr-2 ml-2"
                    :items="getContaReceberSituacoes"
                    v-model="getContaReceber.situacao"
                    label="Situação"
                    outlined
                    dense
                    :rules="rules.situacao"
                    readonly
                  ></v-select>
                </v-flex>

                <v-flex xs12 md2>
                  <v-text-field
                    label="Data de Vencimento"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.data_vencimento"
                    type="date"
                    :rules="rules.data_vencimento"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    label="Data de Vencimento Original"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.data_vencimento_original"
                    type="date"
                    :rules="rules.data_vencimento_original"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    label="Data de Emissão"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.data_emissao"
                    type="date"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    label="Data de Competência"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.data_competencia"
                    type="date"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Valor"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.valor"
                    :readonly="getContaReceber.id ? true : false"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    :rules="rules.valor"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Valor Pago"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.valor_pago"
                    readonly
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    :rules="rules.valor"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs 12 md4>
                  <v-text-field
                    label="Saldo Devedor"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    :value="
                      $helper.formatReal(
                        $helper.cleanFormatReal(getContaReceber.valor) -
                          $helper.cleanFormatReal(getContaReceber.valor_pago)
                      )
                    "
                    readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    :items="getContaReceberFormasPagamento"
                    v-model="getContaReceber.forma_pagamento"
                    label="Forma de Pagamento"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    :rules="rules.forma_pagamento"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    :items="getPortadoresFinanceiro"
                    v-model="getContaReceber.portador_id"
                    item-text="nome"
                    item-value="id"
                    label="Portador"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    append-outer-icon="control_point"
                    @click:append-outer="setModalListarPortadorFinanceiro(true)"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-autocomplete
                    class="mr-2 ml-2"
                    v-model="getContaReceber.grupo_id"
                    :items="getGruposFinanceiro"
                    item-text="nome"
                    item-value="id"
                    label="Categoria"
                    outlined
                    dense
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarGrupoFinanceiro"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    :items="getContaReceberOcorrenciaTipos"
                    v-model="getContaReceber.ocorrencia_tipo"
                    label="Tipo Ocorrência"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    :rules="rules.ocorrencia_tipo"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  v-if="getContaReceber.ocorrencia_tipo != 'PARCELA ÚNICA'"
                >
                  <v-select
                    :items="getContaReceberOcorrencias"
                    v-model="getContaReceber.ocorrencia"
                    label="Ocorrência"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    :rules="rules.ocorrencia"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  v-if="getContaReceber.ocorrencia_tipo != 'PARCELA ÚNICA'"
                >
                  <v-text-field
                    label="Ocorrência (Vezes)"
                    v-model="getContaReceber.ocorrencia_quantidade"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    type="number"
                    :rules="rules.ocorrencia_quantidade"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    label="Informações"
                    outlined
                    dense
                    class="mr-2 ml-2"
                    v-model="getContaReceber.informacoes"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md12>
                  <v-file-input
                    label="Anexo"
                    v-if="getShowInputAnexoContaReceber"
                    @change="selecionaAnexo"
                    outlined
                    dense
                    class="mr-2 ml-2"
                  ></v-file-input>
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="getContaReceber.id && getContaReceber.extrato.length > 0"
          >
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Forma de Pagamento</th>
                    <th>Funcionário</th>
                    <th>Data</th>
                    <th align="center">Tipo</th>
                    <th>Valor</th>
                    <th>Saldo Devedor</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="6"></td>
                    <td>{{ getContaReceber.valor }}</td>
                    <td></td>
                  </tr>
                  <tr v-for="e in getContaReceber.extrato" :key="e.id">
                    <td>{{ e.id }}</td>
                    <td>{{ e.forma_pagamento.nome }}</td>
                    <td>{{ e.funcionario.nome_abreviado }}</td>
                    <td>{{ $helper.formatDateTime(e.created_at) }}</td>
                    <td>{{ e.tipo }}</td>
                    <td>{{ $helper.formatReal(parseFloat(e.valor)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(e.saldo)) }}</td>
                    <td>
                      <v-btn
                        v-if="e.tipo != 'ESTORNO' && e.estornado == false"
                        color="error"
                        outlined
                        small
                        @click="
                          (movimentacaoExtrato = e), (modalEstornarValor = true)
                        "
                        class="mr-1 ml-1"
                        >Estornar</v-btn
                      >
                      <v-btn
                        v-if="e.tipo != 'ESTORNO'"
                        color="default"
                        @click="
                          $store.commit('setMovimentacaoExtratContaReceber', e),
                            setModalReciboParcialContaReceber(true)
                        "
                        outlined
                        small
                        class="mr-1 ml-1"
                        >Recibo</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalCadastroContaReceber(false)"
          outlined
          >Voltar</v-btn
        >
        <v-btn
          color="primary"
          outlined
          @click="cadastrarContaReceber"
          v-if="
            getContaReceber.id &&
            $helper.verificaPermissao('cadastrar-conta-receber')
          "
          >Novo</v-btn
        >
        <v-btn
          color="error"
          outlined
          @click="setModalExcluirContaReceber(true)"
          v-if="
            getContaReceber.id &&
            $helper.verificaPermissao('excluir-conta-receber')
          "
        >
          Excluir</v-btn
        >
        <v-btn
          color="default"
          v-if="
            getContaReceber.id &&
            getContaReceber.venda_id &&
            $helper.verificaPermissao('visualizar-venda')
          "
          @click="visualizarVenda(getContaReceber.venda)"
          outlined
          >Visualizar Venda</v-btn
        >
        <a
          v-if="getContaReceber.anexo && getContaReceber.id"
          :href="getContaReceber.anexo"
          target="_blank"
        >
          <v-btn color="default" class="mr-2 ml-2" outlined
            >Visualizar Anexo</v-btn
          >
        </a>
        <v-btn
          v-if="
            getContaReceber.situacao == 'EM ABERTO' &&
            $helper.verificaPermissao('baixar-conta-receber') &&
            getContaReceber.id
          "
          class="ml-2"
          color="success"
          outlined
          @click="setModalBaixaContaReceber(true)"
          >Baixar</v-btn
        >
        <v-btn
          color="default"
          v-if="getContaReceber.situacao == 'PAGO'"
          @click="setModalReciboTotalContaReceber(true)"
          outlined
          >RECIBO</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            getContaReceber.situacao != 'PAGO' &&
            ($helper.verificaPermissao('cadastrar-conta-receber') ||
              $helper.verificaPermissao('atualizar-conta-receber'))
          "
          color="success"
          @click="salvar"
          outlined
          >Salvar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="modalEstornarValor" persistent max-width="500px">
      <v-card>
        <v-card-title>Estornar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja estornar valor?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            @click="modalEstornarValor = false"
            outlined
            :loading="$store.getters.getOverlay"
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :loading="$store.getters.getOverlay"
            color="error"
            @click="estornarValor()"
            outlined
            >SIM</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalExcluir />
    <!-- <ModalpesquisarContato /> -->
    <ModalCadastroContato />
    <ModalListarPortador />
    <ModalCadastroGrupo />
    <ModalVisualizarVenda />
    <ModalLancamentoCaixa />
    <ModalGerarReciboTotal />
    <ModalGerarReciboParcial />
  </v-dialog>
</template>

<script>
import ModalExcluir from "@/pages/financeiro/contaReceber/ModalExcluir";
import ModalGerarReciboTotal from "@/pages/financeiro/contaReceber/ModalReciboTotal";
import ModalGerarReciboParcial from "@/pages/financeiro/contaReceber/ModalReciboParcial";
// import ModalpesquisarContato from '@/pages/contato/ModalPesquisar'
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalListarPortador from "@/pages/financeiro/portador/Listar";
import ModalCadastroGrupo from "@/pages/financeiro/grupo/ModalCadastro";
import ModalVisualizarVenda from "@/pages/venda/ModalVisualizar";
import ModalLancamentoCaixa from "@/pages/caixa/lancamento/ModalCadastro";
import { mapGetters, mapActions } from "vuex";
import ExtratoContaService from "@/services/ExtratoContaService";

export default {
  components: {
    ModalExcluir,
    // ModalpesquisarContato,
    ModalCadastroContato,
    ModalListarPortador,
    ModalCadastroGrupo,
    ModalVisualizarVenda,
    ModalLancamentoCaixa,
    ModalGerarReciboTotal,
    ModalGerarReciboParcial,
  },
  data() {
    return {
      tabs: 0,
      rules: {
        numero_documento: [(v) => !!v || "Campo obrigatório"],
        cliente_id: [(v) => !!v || "Campo obrigatório"],
        situacao: [(v) => !!v || "Campo obrigatório"],
        data_vencimento: [(v) => !!v || "Campo obrigatório"],
        data_vencimento_original: [(v) => !!v || "Campo obrigatório"],
        valor: [(v) => !!v || "Campo obrigatório"],
        forma_pagamento: [(v) => !!v || "Campo obrigatório"],
        ocorrencia_tipo: [(v) => !!v || "Campo obrigatório"],
        ocorrencia: [(v) => !!v || "Campo obrigatório"],
        ocorrencia_quantidade: [(v) => !!v || "Campo obrigatório."],
      },
      modalEstornarValor: false,
      movimentacaoExtrato: "",
    };
  },
  watch: {
    getModalCadastroContaReceber() {
      if (this.getModalCadastroContaReceber) {
        this.listarContatos({
          pagina: 1,
          id: "",
          nome: "",
          tipo: "",
          cpf_cnpj: "",
          cidade: "",
          telefone: "",
          limit: "",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "getContaReceber",
      "getModalCadastroContaReceber",
      "getContaReceberFormasPagamento",
      "getContaReceberSituacoes",
      "getContatos",
      "getContaPagarPortadores",
      "getGruposFinanceiro",
      "getContaReceberOcorrencias",
      "getContaReceberOcorrenciaTipos",
      "getShowInputAnexoContaReceber",
      "getPortadoresFinanceiro",
    ]),
  },

  methods: {
    ...mapActions([
      "setModalCadastroContaReceber",
      "setModalExcluirContaReceber",
      "cadastrarContaReceber",
      "salvarContaReceber",
      "atualizarContaReceber",
      "setModalPesquisarContato",
      "listarContatos",
      "cadastrarContato",
      "listarGrupoFinanceiro",
      "cadastrarGrupoFinanceiro",
      "setModalListarPortadorFinanceiro",
      "listarPortadorFinanceiro",
      "visualizarVenda",
      "setModalBaixaContaReceber",
      "setModalReciboTotalContaReceber",
      "setModalReciboParcialContaReceber",
    ]),
    salvar() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      const form = new FormData();
      if (this.getContaReceber.cliente_id) {
        form.append("cliente_id", this.getContaReceber.cliente_id);
      }
      if (this.getContaReceber.situacao) {
        form.append("situacao", this.getContaReceber.situacao);
      }
      if (this.getContaReceber.numero_documento) {
        form.append("numero_documento", this.getContaReceber.numero_documento);
      }
      if (this.getContaReceber.data_vencimento) {
        form.append("data_vencimento", this.getContaReceber.data_vencimento);
      }
      if (this.getContaReceber.data_vencimento_original) {
        form.append(
          "data_vencimento_original",
          this.getContaReceber.data_vencimento_original
        );
      }
      if (this.getContaReceber.data_emissao) {
        form.append("data_emissao", this.getContaReceber.data_emissao);
      }
      if (this.getContaReceber.data_competencia) {
        form.append("data_competencia", this.getContaReceber.data_competencia);
      }
      if (this.getContaReceber.valor) {
        form.append("valor", this.getContaReceber.valor);
      }
      if (this.getContaReceber.forma_pagamento) {
        form.append("forma_pagamento", this.getContaReceber.forma_pagamento);
      }
      if (this.getContaReceber.ocorrencia_tipo) {
        form.append("ocorrencia_tipo", this.getContaReceber.ocorrencia_tipo);
      }
      if (this.getContaReceber.ocorrencia) {
        form.append("ocorrencia", this.getContaReceber.ocorrencia);
      }
      if (this.getContaReceber.numero_parcela) {
        form.append("numero_parcela", this.getContaReceber.numero_parcela);
      }
      if (this.getContaReceber.ocorrencia_quantidade) {
        form.append(
          "ocorrencia_quantidade",
          this.getContaReceber.ocorrencia_quantidade
        );
      }
      if (this.getContaReceber.informacoes) {
        form.append("informacoes", this.getContaReceber.informacoes);
      }
      if (this.getContaReceber.portador_id) {
        form.append("portador_id", this.getContaReceber.portador_id);
      }
      if (this.getContaReceber.grupo_id) {
        form.append("grupo_id", this.getContaReceber.grupo_id);
      }
      if (this.getContaReceber.anexo) {
        form.append("anexo", this.getContaReceber.anexo);
      }

      if (this.getContaReceber.id) {
        form.append("_method", "PUT");
        form.append("id", this.getContaReceber.id);
        this.atualizarContaReceber(form);
      } else {
        this.salvarContaReceber(form);
      }
    },
    selecionaAnexo(e) {
      this.getContaReceber.anexo = e;
    },
    estornarValor() {
      this.modalEstornarValor = false;
      this.$store.commit("setOverlay", true);
      ExtratoContaService.estornar(this.movimentacaoExtrato.id)
        .then((res) => {
          console.log(res.data);
          this.movimentacaoExtrato.estornado = true;
          this.getContaReceber.extrato.push(res.data);
          this.$store.commit("setOverlay", false);
          this.$store.commit("setContaReceber", {
            ...this.getContaReceber,
            ...res.data.conta,
          });
        })
        .catch((e) => {
          this.$store.commit("setOverlay", false);
          console.log(e);
        });
    },
  },
  created() {
    this.listarGrupoFinanceiro();
    this.listarPortadorFinanceiro();
  },
};
</script>